import React from 'react';

import AddTopicForm from '@components/pages/Settings/UserProfile/EditTopicsSettings/AddTopicForm';
import TopicList from '@components/pages/Settings/UserProfile/EditTopicsSettings/TopicList';

import MyTISection from './Section';
import TrendingTopicPills from './TrendingTopicPills';

const MyTITopics = ({ initialCurrentUser }) => {
  return (
    <MyTISection
      highlight="Label"
      subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos."
      title="Topics"
    >
      <div className="mt-32 flex flex-col gap-32 sm:flex-row md:gap-[156px]">
        <div className="flex flex-1 flex-col gap-32 border-0 border-solid border-grayscale-gray sm:border-r sm:pr-32 md:pr-[156px]">
          <div className="relative flex w-full flex-col gap-16">
            <h3 className="m-0 font-suisse-intl text-body-lg font-normal text-black">
              Trending topics / Search for topics
            </h3>
            <AddTopicForm className="w-full" identityId={initialCurrentUser.identity_id} />
          </div>
          <TrendingTopicPills identityId={initialCurrentUser.identity_id} />
        </div>
        <div className="flex flex-1 flex-col gap-24">
          <h3 className="m-0 font-suisse-intl text-body-lg font-normal text-black">Following</h3>
          <div className="flex flex-wrap">
            <TopicList identityId={initialCurrentUser.identity_id} />
          </div>
        </div>
      </div>
    </MyTISection>
  );
};

export default MyTITopics;
